import {
  Box,
  HStack,
  IconButton,
  Tooltip,
  useColorModeValue,
} from "@chakra-ui/react";
import { FormInputControl } from "../../components/forms";
import {
  FormSelectControl,
  ISelectOption,
} from "../../components/forms/SelectControl";
import { MaterialIcon } from "../../components/shared/MaterialIcon";
import {
  ENCRYPT_LOGIC_SELECT,
  ENCRYPT_OPERATORS,
} from "../registries/models/Encrypt";

interface IProps {
  name: string;
  isShowLogic: boolean;
  onRemove: () => void;
  columns: ISelectOption[];
}

export const FormQueryConditionPill = ({
  name,
  isShowLogic,
  onRemove,
  columns,
}: IProps) => {
  const colorLogic = useColorModeValue("accent.600", "accent.300");
  const bgLogic = useColorModeValue("accent.50", "accent.800");

  const handleOnRemoveFilter = () => {
    onRemove();
  };

  return (
    <HStack spacing={6}>
      {isShowLogic && (
        <FormSelectControl
          name={`${name}.logic`}
          placeholder=""
          options={ENCRYPT_LOGIC_SELECT}
          formControlProps={{
            maxW: "6rem",
          }}
          borderWidth={1}
          rounded="full"
          borderColor={colorLogic}
          color={colorLogic}
          bg={bgLogic}
          size="sm"
          // variant="unstyled"
        ></FormSelectControl>
      )}

      <HStack flex={1} spacing={6} px={4} py={3} borderWidth={1} bg="bg.high">
        <Box>
          <MaterialIcon
            color="text.softer"
            name="filter_alt"
            variant="outline"
            fontSize="1.25rem"
          />
        </Box>

        <FormSelectControl
          name={`${name}.field`}
          placeholder=""
          options={columns}
          // formControlProps={{
          //   maxW: "16rem",
          // }}
          bg="bg.main"
        ></FormSelectControl>

        <FormSelectControl
          name={`${name}.operator`}
          placeholder=""
          options={ENCRYPT_OPERATORS}
          formControlProps={{
            maxW: "6rem",
          }}
          bg="bg.main"
        ></FormSelectControl>

        <FormInputControl
          name={`${name}.search`}
          placeholder=""
          formControlProps={{
            maxW: "22rem",
          }}
          bg="bg.main"
        />

        <Box>
          <Tooltip label="Remove Filter">
            <IconButton
              onClick={handleOnRemoveFilter}
              icon={
                <MaterialIcon
                  color="text.soft"
                  name="delete"
                  fontSize="1.25rem"
                  variant="outline"
                />
              }
              aria-label="remove filters columns"
            ></IconButton>
          </Tooltip>
        </Box>
      </HStack>
    </HStack>
  );
};
